import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { SuccessDTO } from "../../dto";

type ModifyCorrectDisappearingProps = {
  lineOfPoetryId: number;
  id: number;
};

let body: SuccessDTO;

export async function modifyCorrectDisappearingAction(
  props: ModifyCorrectDisappearingProps
) {
  const token = localStorage.getItem("token");

  const params = {
    lineOfPoetryId: props.lineOfPoetryId,
    id: props.id,
  };

  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/disappearing-game-options/modify-correct-answer`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(SuccessDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
